import React, { useState, useEffect, useContext } from 'react';
import { Container, Table, Button, Row, Col, Badge, Alert } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';
import api from '../../services/api';
import './User.css';

const UserList = () => {
  const { user } = useContext(AuthContext);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  
  // 確保只有管理員可以訪問
  useEffect(() => {
    if (user?.role !== 0) {
      navigate('/');
    }
  }, [user, navigate]);
  
  // 載入用戶列表
  useEffect(() => {
    if (user?.role === 0) {
      loadUsers();
    }
  }, [user]);
  
  const loadUsers = async () => {
    setLoading(true);
    try {
      console.log('正在請求用戶列表...');
      const response = await api.get('/users');
      console.log('收到響應:', response);
      setUsers(response.data.data || []);
      setError('');
    } catch (err) {
      console.error('載入用戶失敗:', err);
      console.error('錯誤詳情:', err.response?.data || err.message);
      setError('載入用戶失敗，請稍後再試');
    } finally {
      setLoading(false);
    }
  };
  
  // 切換用戶活躍狀態
  const handleToggleStatus = async (userId, currentStatus) => {
    try {
      await api.put(`/users/${userId}/status`, {
        inactive: currentStatus === 1 ? 0 : 1
      });
      
      // 重新載入用戶列表
      loadUsers();
    } catch (err) {
      console.error('更新用戶狀態失敗:', err);
      setError('更新用戶狀態失敗，請稍後再試');
    }
  };
  
  const getRoleName = (roleCode) => {
    switch(roleCode) {
      case 0: return '管理員';
      case 1: return '客戶';
      default: return `角色(${roleCode})`;
    }
  };
  
  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('zh-TW');
  };

  return (
    <Container className="user-list-container">
      <Row className="mb-3 align-items-center">
        <Col xs={12} md={6}>
          <h2>用戶管理</h2>
        </Col>
        <Col xs={12} md={6} className="text-md-end">
          <Button variant="outline-secondary" className="me-2" onClick={loadUsers}>
            刷新
          </Button>
          <Button variant="primary" as={Link} to="/users/new">
            新增用戶
          </Button>
        </Col>
      </Row>
      
      {error && <Alert variant="danger">{error}</Alert>}
      
      {loading ? (
        <div className="text-center my-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">載入中...</span>
          </div>
        </div>
      ) : users.length === 0 ? (
        <div className="text-center my-5">
          <p>尚無用戶記錄</p>
          <Button variant="primary" as={Link} to="/users/new">
            新增用戶
          </Button>
        </div>
      ) : (
        <div className="table-responsive">
          <Table hover className="user-table">
            <thead>
              <tr>
                <th>登入ID</th>
                <th>角色</th>
                <th>電話</th>
                <th>建立日期</th>
                <th>最後登入</th>
                <th>狀態</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user) => (
                <tr key={user.uid}>
                  <td>{user.login_id}</td>
                  <td>{getRoleName(user.role)}</td>
                  <td>{user.phone || '-'}</td>
                  <td>{formatDate(user.created_at)}</td>
                  <td>{formatDate(user.login_at)}</td>
                  <td>
                    {user.inactive === 0 ? (
                      <Badge bg="success">啟用</Badge>
                    ) : (
                      <Badge bg="danger">停用</Badge>
                    )}
                  </td>
                  <td>
                    <Button 
                      variant="link" 
                      className="p-0 text-primary me-2" 
                      as={Link} 
                      to={`/users/edit/${user.uid}`}
                    >
                      編輯
                    </Button>
                    
                    <Button 
                      variant="link" 
                      className={`p-0 ${user.inactive === 0 ? 'text-danger' : 'text-success'}`}
                      onClick={() => handleToggleStatus(user.uid, user.inactive)}
                    >
                      {user.inactive === 0 ? '停用' : '啟用'}
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}
    </Container>
  );
};

export default UserList;